import React, { Component } from "react";
import { Layout } from "antd";

import Login from "./Login";
import { Link } from "react-router-dom";

import CreateAccount from "./CreateAccount";

import LogoutLayout from "./LogoutLayout";

const { Header } = Layout;

class HeaderLayout extends Component {
  render() {
    return (
      <Header
        className="site-layout-background"
        style={{ padding: 0, color: "white", position: "relative",zIndex:"22"}}
      >
        <h1>
          <Link to="/">React Final Project</Link>
        </h1>
        {this.props.login ? (
          <div>
          <span style={{marginRight:"1.5rem",fontSize:"1.1rem"}}>Hi, {this.props.user}</span>
            <LogoutLayout />
          </div>
        ) : (
          <div>
            <Login />
            <CreateAccount />
          </div>
        )}
      </Header>
    );
  }
}

export default HeaderLayout;
